import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Norsk Bokm\xE5l",
  code: "nb-NO",
  messages: {
    alert: {
      close: "Lukk"
    },
    authForm: {
      hidePassword: "Skjul passord",
      showPassword: "Vis passord",
      submit: "Fortsett"
    },
    banner: {
      close: "Lukk"
    },
    calendar: {
      nextMonth: "Neste m\xE5ned",
      nextYear: "Neste \xE5r",
      prevMonth: "Forrige m\xE5ned",
      prevYear: "Forrige \xE5r"
    },
    carousel: {
      dots: "Velg lysbilde som skal vises",
      goto: "G\xE5 til lysbilde {slide}",
      next: "Neste",
      prev: "Forrige"
    },
    chatPrompt: {
      placeholder: "Skriv din melding her..."
    },
    chatPromptSubmit: {
      label: "Send"
    },
    colorMode: {
      dark: "M\xF8rk",
      light: "Lys",
      switchToDark: "Bytt til m\xF8rk modus",
      switchToLight: "Bytt til lys modus",
      system: "System"
    },
    commandPalette: {
      back: "Tilbake",
      close: "Lukk",
      noData: "Ingen data",
      noMatch: "Ingen samsvarende data",
      placeholder: "Skriv inn en kommando eller s\xF8k..."
    },
    contentSearch: {
      links: "Lenker",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "S\xF8k..."
    },
    contentToc: {
      title: "P\xE5 denne siden"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "S\xF8k..."
    },
    dashboardSidebarCollapse: {
      collapse: "Skjul sidepanel",
      expand: "Utvid sidepanel"
    },
    dashboardSidebarToggle: {
      close: "Lukk sidepanel",
      open: "\xC5pne sidepanel"
    },
    error: {
      clear: "Tilbake til forsiden"
    },
    fileUpload: {
      removeFile: "Fjern {filename}"
    },
    header: {
      close: "Lukk meny",
      open: "\xC5pne meny"
    },
    inputMenu: {
      create: 'Opprett "{label}"',
      noData: "Ingen data",
      noMatch: "Ingen samsvarende data"
    },
    inputNumber: {
      decrement: "Reduser",
      increment: "\xD8k"
    },
    modal: {
      close: "Lukk"
    },
    pricingTable: {
      caption: "Prisplaneringssammenligning"
    },
    prose: {
      codeCollapse: {
        closeText: "Skjul",
        name: "kode",
        openText: "Utvid"
      },
      collapsible: {
        closeText: "Skjul",
        name: "egenskaper",
        openText: "Vis"
      },
      pre: {
        copy: "Kopier kode til utklippstavle"
      }
    },
    selectMenu: {
      create: 'Opprett "{label}"',
      noData: "Ingen data",
      noMatch: "Ingen samsvarende data",
      search: "S\xF8k..."
    },
    slideover: {
      close: "Lukk"
    },
    table: {
      noData: "Ingen data"
    },
    toast: {
      close: "Lukk"
    }
  }
});
